var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllskills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.821,
    height: 11.606,
    viewBox: "0 0 17.821 11.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer",
    transform: "translate(-1.85 -5.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_692",
    fill: "#bfbfbf",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: "0.3px",
    d: "M14.264 6H7.256A5.465 5.465 0 0 0 2 11.653a5.465 5.465 0 0 0 5.256 5.653h7.008a5.465 5.465 0 0 0 5.256-5.653A5.465 5.465 0 0 0 14.264 6zM3.752 11.653a3.644 3.644 0 0 1 3.5-3.769 3.644 3.644 0 0 1 3.5 3.769 3.644 3.644 0 0 1-3.5 3.769 3.644 3.644 0 0 1-3.5-3.769zm10.512 3.769h-3.1a5.975 5.975 0 0 0 0-7.537h3.1a3.644 3.644 0 0 1 3.5 3.769 3.644 3.644 0 0 1-3.5 3.768z",
    "data-name": "Trazado 692"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllskills);
export default __webpack_public_path__ + "static/media/allskills.6508ed08362e7be94de9a13b2a4f5bba.svg";
export { ForwardRef as ReactComponent };